skrilla.service('dateService', function (cacheService) {

    const timezones = {
        LOCAL: {
            name:"Local",
            fullName: "Local (" + Intl.DateTimeFormat().resolvedOptions().timeZone + ")",
            offset: new Date().getTimezoneOffset() * -1,
        },
        UTC: {
            offset: 0,
            name: "UTC",
            fullName: "UTC"
        },
        AEST: {
            offset: 600,
            name: "AEST",
            fullName: "AEST"
        }
    }

    var timezone = cacheService.getObject("timezone") || timezones["LOCAL"]


    //Add the timezone difference on to the date so that when it's converted to UTC it's still the date the admin selected.
    var compensateForTimezone = function (date_) {
        var offset = new Date().getTimezoneOffset() * -1;
        var date = new Date(date_);
        date = new Date(date.getTime() + offset * 60000)
        return date;
    }

    var getUTC = function (date_) {
        var date = new Date(date_);
        var mins = date.getMinutes();
        date.setMinutes(date.getTimezoneOffset());
        date.setMinutes(mins);
        return dateToString(date);
    }

    var getUnchangedDateToString = function (date_) {
        var date = new Date(date_);
        return dateToString(date);
    }

    var getLocal = function (date_, simple = false) {
        var offset = new Date().getTimezoneOffset() * -1;
        var date = new Date(date_);
        date = new Date(date.getTime() + offset * 60000)
        return dateToString(date, simple);
    }

    function dateToString(date, simple = false) {
        var simpleDate = getNumber(date.getDate()) + "-" +
            getNumber(date.getMonth() + 1) + "-" +
            date.getFullYear()
        return simple ? simpleDate : simpleDate + " " +
            getNumber(date.getHours()) + ":" +
            getNumber(date.getMinutes()) + ":" +
            getNumber(date.getSeconds())
    }

    function getTimeZonePreference() {
        return cacheService.getObject("timezone") || timezones["LOCAL"];
    }

    function getTimeZones() {
        return timezones;
    }

    function getDate(date, timezone_) {
        if (timezone_ === undefined) {
            timezone_ = getTimeZonePreference();
        }
        var date_ = new Date(date);
        date_ = new Date(date_.getTime() + timezone_.offset * 60000)
        return date_;
    }

    function getNumber(i) {
        return i > 9 ? i : "0" + i;
    }

    function formatDate(date) {
        let month = date.getMonth();
        month = parseInt(month);
        month += 1;
        if (month < 10) {
            month = "0" + month;
        }
        let day = date.getDate();
        day = parseInt(day);
        if (day < 10) {
            day = "0" + day;
        }
        const year = date.getFullYear();
        date = year + "-" + month + "-" + day;
        return date;
    }

    function getTomorrowDate() {
        return new Date((new Date()).valueOf() + 86400000)
    }

    return {
        getUTC,
        getLocal,
        getDate,
        getUnchangedDateToString,
        compensateForTimezone,
        getTimeZonePreference,
        getTimeZones,
        formatDate,
        getTomorrowDate,
    };
});
